import { getDataApi1 } from "../../services/appApi";

export const getSelectedTaxYear = () => {
  const selectedTaxYear = localStorage.getItem("taxSelectedTaxYear");
  return selectedTaxYear && /^\d{4}$/.test(selectedTaxYear)
    ? selectedTaxYear
    : "2025";
};

export const includeSelectedTaxYearOption = (options) => {
  const selectedTaxYear = getSelectedTaxYear();
  return options.some((option) => String(option.value) === selectedTaxYear)
    ? options
    : [...options, { label: selectedTaxYear, value: selectedTaxYear }];
};

export const fetchTaxYearOptions = async () => {
  let offset = 0;
  const limit = 25;
  let hasMore = true;
  const allData = [];

  while (hasMore) {
    const response = await getDataApi1(`/ztx_tax_years_v/?offset=${offset}&limit=${limit}`);
    const responseData = response.data;
    const pageData = Array.isArray(responseData?.o_return_data_rc)
      ? responseData.o_return_data_rc
      : Array.isArray(responseData?.items)
        ? responseData.items
        : [];

    allData.push(...pageData);
    hasMore = responseData?.hasMore === true || responseData?.hasMore === "true";
    offset += limit;
  }

  return allData
    .filter((item) => item.tax_year !== null && item.tax_year !== undefined)
    .sort((first, second) => Number(second.tax_year) - Number(first.tax_year))
    .map((item) => ({
      label: String(item.tax_year),
      value: String(item.tax_year),
    }));
};
